<template>
  <div class="markdown-text" v-html="compiled">
  </div>
</template>

<script>
import marked from 'marked'

export default {
  name: 'MarkdownView',

  computed: {
    compiled(){
      return marked(this.text.trim())
    }
  },

  props: {
    text: String
  }
}
</script>

<style>
.markdown-text ul {
  margin-bottom: 0;
}

.markdown-text p {
  margin-bottom: 0.3rem;
}

.markdown-text h1 {
  font-size: 1.3rem;
  margin-bottom: 0.3rem;
}

.markdown-text h2 {
  font-size: 1.2rem;
  margin-bottom: 0.3rem;
}

.markdown-text h3 {
  font-size: 1.1rem;
  margin-bottom: 0.3rem;
}

.markdown-text h4,
.markdown-text h5,
.markdown-text h6,
.markdown-text h7 {
  font-size: 1rem;
  margin-bottom: 0.3rem;
}
</style>
